import firebase from 'firebase/app'
import 'firebase/firestore'

// Get a Firestore instance
export const db = firebase
  .initializeApp({
    apiKey: "AIzaSyCUX7TTm0XrUjKO1F5NkceKy0jEWBcE2KA",
    authDomain: "teamci.firebaseapp.com",
    databaseURL: "https://teamci.firebaseio.com",
    projectId: "teamci",
    storageBucket: "teamci.appspot.com",
    messagingSenderId: "207536180122",
    appId: "1:207536180122:web:37802cd32c903cc80c4823",
    measurementId: "G-EP6L0Y5MP7",
  })

  .firestore();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore;
export { Timestamp, GeoPoint }
